import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { api } from './services/api';
import { boxEditMetricsListener } from './services/boxEditMetrics';
import { logoutListener } from './services/logout';
import auth, { syncAuthFromStorageAction } from './slices/authSlice';
import { AUTH_TOKEN_STORAGE_KEY } from './slices/authSlice.keys';
import editPage from './slices/editPageSlice';
import user from './slices/userSlice';
import company from './slices/companySlice';
import notification from './slices/notificationSlice';

export const store = configureStore({
  reducer: {
    auth,
    editPage,
    user,
    company,
    notification,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Large docs accumulate many page item trees; deep walks trip the
        // default 32ms warning in development when scrolling/editing.
        warnAfter: 128,
        ignoredPaths: ['editPage.pages'],
      },
    })
      .prepend(logoutListener.middleware, boxEditMetricsListener.middleware)
      .concat(api.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootStateType = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootStateType,
  unknown,
  Action<string>
>;

/**
 * Multi-tab: a token written, refreshed or removed in another tab is adopted
 * here. A removed token is a deliberate logout in that tab.
 */
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key !== null && event.key !== AUTH_TOKEN_STORAGE_KEY) return;
    store.dispatch(syncAuthFromStorageAction());
  });
}
